import { SvgIcon } from '@mui/material'

export default function TotalOrdersIcon() {
  return (
    <SvgIcon sx={{ width: 20, height: 20 }}>
      <svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <title>Total Orders</title>
        <path
          d='M10 18.3335C9.31817 18.3335 8.66683 18.0583 7.36411 17.5081C4.12137 16.1382 2.5 15.4533 2.5 14.3012C2.5 13.9787 2.5 8.38725 2.5 5.8335M10 18.3335C10.6818 18.3335 11.3332 18.0583 12.6359 17.5081C15.8787 16.1382 17.5 15.4533 17.5 14.3012V5.8335M10 18.3335V9.4625'
          stroke='#153CB7'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.93827 8.07599L4.50393 6.89805C3.16797 6.25159 2.5 5.92836 2.5 5.4165C2.5 4.90465 3.16797 4.58142 4.50393 3.93496L6.93827 2.75702C8.44067 2.03001 9.19192 1.6665 10 1.6665C10.8081 1.6665 11.5593 2.03 13.0617 2.75702L15.4961 3.93496C16.832 4.58142 17.5 4.90465 17.5 5.4165C17.5 5.92836 16.832 6.25159 15.4961 6.89805L13.0617 8.07599C11.5593 8.803 10.8081 9.1665 10 9.1665C9.19192 9.1665 8.44067 8.803 6.93827 8.07599Z'
          stroke='#153CB7'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5 10L6.66667 10.8333'
          stroke='#153CB7'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.1667 3.3335L5.83337 7.50016'
          stroke='#153CB7'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  )
}
